<div class="container">
    <div class="titre">Pourquoi choisir la Maison de l'Assurance du Centre Est ?</div>
    <div class="arguments">
        <div class="arg">
            <div class="image">
                  <picture>
                            <!-- WebP -->
                            <source
                                type="image/webp"
                                srcset="./../../../assets/webp/tel.webp"
                                alt="tel"
                            >
                            <!-- Fallback -->
                            <img src="./../../../assets/tel.png" alt="tel">
                    </picture>
            </div>
            <div class="texte">A l'écoute</div>
        </div>
        <div class="arg">
            <div class="image">
                <picture>
                            <!-- WebP -->
                            <source
                                type="image/webp"
                                srcset="./../../../assets/webp/cle.webp"
                                alt="clé"
                            >
                            <!-- Fallback -->
                            <img src="./../../../assets/cle.png" alt="clé">
                    </picture>
            </div>
            <div class="texte">Conseils</div>
        </div>
        <div class="arg">
            <div class="image">
                <picture>
                            <!-- WebP -->
                            <source
                                type="image/webp"
                                srcset="./../../../assets/webp/devis.webp"
                                alt="devis"
                            >
                            <!-- Fallback -->
                            <img src="./../../../assets/devis.png" alt="devis">
                    </picture>
            </div>
            <div class="texte">Devis gratuit</div>
        </div>
    </div>
</div>